import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import { Loader2, CheckCircle, AlertCircle } from 'lucide-react';

const AuthCallback = () => {
  const [message, setMessage] = useState("Traitement de l'authentification...");
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('🔄 Traitement du callback d\'authentification...');
        
        // Parser le hash pour les paramètres d'auth
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const accessToken = hashParams.get('access_token');
        const refreshToken = hashParams.get('refresh_token');
        const type = hashParams.get('type');

        console.log('📝 Paramètres du hash:', { type, hasAccessToken: !!accessToken, hasRefreshToken: !!refreshToken });

        // Si on a les tokens du magic link, les établir
        if (accessToken && refreshToken && type === 'magiclink') {
          console.log('🔐 Magic link détecté, établissement de la session...');
          const { error: setSessionError } = await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken
          });

          if (setSessionError) {
            console.error('❌ Erreur lors de l\'établissement de la session:', setSessionError);
            throw setSessionError;
          }

          console.log('✅ Session établie');
          // Nettoyer l'URL
          window.history.replaceState({}, document.title, '/auth/callback');
        }

        // Récupérer la session
        const { data: { session }, error: sessionError } = await supabase.auth.getSession();

        if (sessionError) {
          console.error('❌ Erreur session:', sessionError);
          throw new Error('Échec de récupération de la session');
        }

        if (!session) {
          console.error('❌ Aucune session trouvée');
          throw new Error('Aucune session active. Le lien a peut-être expiré.');
        }

        console.log('✅ Session récupérée:', session.user.email);
        
        setSuccess(true);
        setMessage('✅ Authentification réussie !');

        // Redirection directe vers l'accueil
        setTimeout(() => {
          navigate('/', { replace: true });
        }, 1500);

      } catch (err) {
        console.error('❌ Erreur dans handleCallback:', err);
        setError(err.message || 'Une erreur est survenue lors de l\'authentification');
        setMessage('');
      }
    };

    handleCallback();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800">
        <div className="bg-slate-800/70 backdrop-blur-sm p-8 rounded-2xl shadow-xl max-w-md w-full border border-slate-700">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-8 h-8 text-red-400" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">
              Erreur d'authentification
            </h2>
            <p className="text-slate-400">{error}</p>
          </div>
          
          <button
            onClick={() => navigate('/login')}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-lg transition-colors font-medium"
          >
            Retour à la connexion
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="bg-slate-800/70 backdrop-blur-sm p-8 rounded-2xl shadow-xl max-w-md w-full border border-slate-700 text-center">
        {success ? (
          <>
            <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-green-400" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-2">
              Authentification réussie !
            </h2>
            <p className="text-slate-400">Redirection en cours...</p>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-blue-400 animate-spin mx-auto mb-4" />
            <p className="text-white text-lg">{message}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;